import React from "react";
import { Link } from "react-router-dom";

/**
 * LegalFooter - A reusable footer component that displays legal links
 * Required for app-store and payment-gateway compliance
 * Must be visible on ALL pages (non-negotiable)
 */
const LegalFooter = ({ variant = "default" }) => {
  // Compact variant for pages with existing footers
  if (variant === "compact") {
    return (
      <div className="py-5 px-4 sm:px-6 border-t border-slate-200 bg-slate-100 mb-16 sm:mb-0">
        <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-center gap-3 sm:gap-5 text-xs sm:text-sm font-medium text-slate-700">
          <Link to="/about" className="hover:text-slate-900 hover:underline transition-colors">
            About
          </Link>
          <span className="text-slate-400 hidden sm:inline">|</span>
          <Link to="/account-settings" className="hover:text-slate-900 hover:underline transition-colors">
            Account
          </Link>
          <span className="text-slate-400 hidden sm:inline">|</span>
          <Link to="/help" className="hover:text-slate-900 hover:underline transition-colors">
            Help & FAQ
          </Link>
          <span className="text-slate-400 hidden sm:inline">|</span>
          <Link to="/terms-of-service" className="hover:text-slate-900 hover:underline transition-colors">
            Terms
          </Link>
          <span className="text-slate-400 hidden sm:inline">|</span>
          <Link to="/privacy-policy" className="hover:text-slate-900 hover:underline transition-colors">
            Privacy
          </Link>
          <span className="text-slate-400 hidden sm:inline">|</span>
          <Link to="/refund-policy" className="hover:text-slate-900 hover:underline transition-colors">
            Refunds
          </Link>
        </div>
      </div>
    );
  }

  // Minimal variant for inline use
  if (variant === "minimal") {
    return (
      <div className="text-center text-xs text-slate-500 py-2">
        <Link to="/about" className="hover:text-slate-700 hover:underline">About</Link>
        {" · "}
        <Link to="/terms-of-service" className="hover:text-slate-700 hover:underline">Terms</Link>
        {" · "}
        <Link to="/privacy-policy" className="hover:text-slate-700 hover:underline">Privacy</Link>
        {" · "}
        <Link to="/refund-policy" className="hover:text-slate-700 hover:underline">Refund Policy</Link>
      </div>
    );
  }

  // Default full footer
  return (
    <footer className="py-8 px-6 border-t border-slate-200 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <span className="text-lg font-semibold text-slate-900">CLARIAS</span>
            <span className="text-sm text-slate-500">— Clarity over chaos</span>
          </div>
          <div className="flex flex-wrap items-center gap-4 text-sm text-slate-500">
            <Link to="/about" className="hover:text-slate-700 transition-colors">About</Link>
            <span className="text-slate-300">|</span>
            <Link to="/help" className="hover:text-slate-700 transition-colors">Help & FAQ</Link>
            <span className="text-slate-300">|</span>
            <Link to="/terms-of-service" className="hover:text-slate-700 transition-colors">Terms of Service</Link>
            <span className="text-slate-300">|</span>
            <Link to="/privacy-policy" className="hover:text-slate-700 transition-colors">Privacy Policy</Link>
            <span className="text-slate-300">|</span>
            <Link to="/refund-policy" className="hover:text-slate-700 transition-colors">Refund Policy</Link>
          </div>
        </div>
        
        {/* No Guarantee Disclaimer - MANDATORY */}
        <div className="mt-4 text-center">
          <p className="text-xs text-slate-400">
            CLARIAS provides educational assistance. It does not guarantee selection, rank, marks, or exam results.
          </p>
        </div>
        
        {/* Support Contact & Copyright */}
        <div className="mt-3 text-center space-y-1">
          <p className="text-xs text-slate-400">
            Customer Support & Grievance Contact: <a href="mailto:support@clarias.in" className="hover:text-slate-600 underline">support@clarias.in</a>
          </p>
          <p className="text-xs text-slate-400">
            Copyright © 2025–{new Date().getFullYear()} CLARIAS. All rights reserved. Not affiliated with UPSC or Government of India.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;
